export default class ImageManager {



  /**
   * constructor
   */
  constructor() {
    this.caches = {};
  }



  /**
   * to data uri
   */
  toDataUri(src) {
    const cacheKey = encodeURIComponent(src);

    if (this.caches[cacheKey]) return this.caches[cacheKey].promise;

    const cache = {
      src    : src,
      dataUri: null,
    };

    cache.promise = new Promise((resolve, reject) => {
      let canvas = document.createElement('canvas');
      let ctx    = canvas.getContext('2d');
      let img    = document.createElement('img');

      const cleanUp = () => {
        canvas = null;
        ctx    = null;
        img    = null;
      }

      const onDone = () => {
        cleanUp();
        resolve(cache.dataUri);
      }

      const onError = e => {
        cleanUp();
        reject(e);
      }

      img.onload = function () {
        canvas.width  = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        try {
          cache.dataUri = canvas.toDataURL('image/png');
        } catch(e) {
          return onError(e);
        }

        return onDone();
      }

      img.onerror = function () {
        onError(new Error('画像が読み込めませんでした'));
      }

      img.src = src;
    });

    this.caches[cacheKey] = cache;
    return cache.promise;
  }
}


// WEBPACK FOOTER //
// ./src/shared/core/ImageManager.js